import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.copyImportValue)?_c(VBtn,_vm._g(_vm._b({attrs:{"icon":"","color":_vm.check ? 'teal': 'red'},on:{"click":function($event){return _vm.copyToClipboard(_vm.newValue)}}},'v-btn',attrs,false),on),[_c(VIcon,[_vm._v("mdi-content-copy")])],1):_c(VIcon,_vm._g(_vm._b({attrs:{"color":_vm.check ? 'teal': 'red'}},'v-icon',attrs,false),on),[_vm._v(" mdi-check-circle ")])]}}])},[_c('ul',[_c('li',[_vm._v("WIMS: "+_vm._s(_vm.originalValue))]),_c('li',[_vm._v("IMPORTER: "+_vm._s(_vm.newValue))])])])}
var staticRenderFns = []

export { render, staticRenderFns }